import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import * as echarts from 'echarts/core'
import {
    BarChart, LineChart, PieChart, RadarChart,
    ScatterChart, GaugeChart, MapChart
} from 'echarts/charts'
import {
    TitleComponent, TooltipComponent, GridComponent,
    LegendComponent, DataZoomComponent, VisualMapComponent,
    ToolboxComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
    CanvasRenderer,
    BarChart, LineChart, PieChart, RadarChart,
    ScatterChart, GaugeChart, MapChart,
    TitleComponent, TooltipComponent, GridComponent,
    LegendComponent, DataZoomComponent, VisualMapComponent,
    ToolboxComponent
])

// 全局注册 echarts
Vue.prototype.$echarts = echarts

// 自定义全局主题
const theme = {
    color: [
        '#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
        '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa',
        '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050',
        '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'
    ],
    backgroundColor: 'rgba(0,0,0,0)',
    textStyle: {
        fontFamily: 'Arial, sans-serif'
    },
    title: {
        textStyle: {
            color: '#fff',
            fontSize: 14
        }
    },
    tooltip: {
        backgroundColor: 'rgba(50,50,50,0.7)',
        borderColor: '#444',
        textStyle: {
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: '#ccc'
        }
    },
    grid: {
        borderWidth: 0,
        borderColor: '#666',
        textStyle: {
            color: '#fff'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: '#ccc'
        }
    },
    dataZoom: {
        backgroundColor: 'rgba(0,0,0,0.2)',
        dataBackgroundColor: 'rgba(181, 181, 181, 0.3)',
        fillerColor: 'rgba(181, 181, 181, 0.2)',
        handleColor: '#5e95c7'
    },
    visualMap: {
        textStyle: {
            color: '#ccc'
        }
    }
}

// 注册全局主题
echarts.registerTheme('data-screen', theme)

// 创建全局混入，处理图表响应式
Vue.mixin({
    mounted() {
        if (this.$options.echartResize) {
            window.addEventListener('resize', this.handleResize)
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', this.handleResize)
            })
        }
    },
    methods: {
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize()
            }
        }
    }
})
Vue.config.productionTip = false

Vue.use(dataV)
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '默认应用标题';
  }
  next();
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
